<template>
	<div>
		<div class="d-flex justify-space-between mt-6">
			<div class="flex-column flex-sm-row d-flex justify-sm-start">
				<botao-primario
					v-az-auth="permissoes.pedidoUtilizacaoEditar"
					v-if="(hasAuthority || isPedidoRascunho) && !isPedidoEfetivado() && !isAtaCancelada"
					nome-botao="ADICIONAR"
					icone="add_circle"
					class="botao-tamanho-arp mr-2"
					@click="irParaSelecaoItens"
				></botao-primario>
				<acessar-pedido-itens-btn-mais-acoes
					class="mr-2"
					v-if="botaoAcoesEmMassaPodeAparecer && !isAtaCancelada"
					:block="$vuetify.breakpoint.smAndDown"
					:permissoes-em-massa="permissoesBotoesAcoesEmMassa"
					@estornar-itens="abrirModalEstornoItemPedido(itensSelecionadosListagem, true)"
				>
				</acessar-pedido-itens-btn-mais-acoes>
				<botao-primario
					v-az-auth="permissoes.pedidoUtilizacaoGerarRelatorioPrevio"
					v-if="
						(hasAuthority || isPedidoRascunho) &&
						isPermissaoAutorizada(permissoes.pedidoUtilizacaoGerarRelatorioPrevio)
					"
					id="visualizarPedido"
					outlined
					icone="description"
					cor-icone="primary"
					nome-botao="VISUALIZAR PEDIDO"
					@click="baixarRelatorioPrevio"
				></botao-primario>
			</div>
			<az-search
				:filter="filtro"
				simple-search-placeholder="Busque por: tipo ou descrição"
				@simple-search="buscarFiltro"
				ref="componenteAzSearch"
				@remove-filter="removerFiltros"
			>
			</az-search>
		</div>
		<div class="arp-listagem-itens__listagem mt-3">
			<v-row>
				<v-col cols="12" sm="12" class="flex-column d-flex justify-sm-start">
					<acessar-pedido-itens-listagem
						:total-paginas="listagem.totalPaginas"
						:total-itens="listagem.totalItens"
						:paginacao="listagem.paginacao"
						:itens="listagem.datasource"
						@paginar="paginarListagem"
						@resetar-page="resetarPaginaListagem"
						@resetar-valor-total="carregarTotal"
						@excluir="abrirModalConfirmacaoExclusao"
						@abrir-estorno="abrirModalEstornoItemPedido"
					></acessar-pedido-itens-listagem>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="3" offset-sm="9"> </v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="3" offset-sm="9"> </v-col>
			</v-row>
		</div>
		<v-divider></v-divider>
		<v-form ref="form" v-model="formRodapeIsValid" lazy-validation>
			<div class="my-3">
				<v-row>
					<v-col cols="12" sm="3">
						<label-personalizado
							nome-campo="N° Processo"
							:obrigatorioPorPadrao="numeroProcessoObrigatorio"
							:mensagemPadraoTooltip="tooltipMascaraNumeroProcesso"
							:apresentaTooltip="ehMascaraNumeroProcessoAtivo"
						></label-personalizado>
						<campo-mascara-regex
							id="numeroProcesso"
							v-model="numeroProcesso"
							name="N° Processo"
							clearable
							:rules="regrasNumeroProcesso"
							:validate="{ required: numeroProcessoObrigatorio, regex: validacaoMascaraNumeroProcesso }"
							maxlength="50"
							:placeholder="podeExibirSecaoProtocolo ? '' : 'Informe o número do processo'"
							:regex="mascaraNumeroProcesso"
							:disabled="
								podeExibirSecaoProtocolo ||
								pedidoProtocolado ||
								(!podeAlterarNumeroProcesso && !hasAuthority) ||
								isAtaCancelada
							"
						></campo-mascara-regex>
					</v-col>
					<v-col cols="6" :sm="usaNumeroEmpenho ? 3 : 5">
						<label-personalizado
							nome-campo="Contratos Vinculados"
							apresenta-tooltip
							mensagem-padrao-tooltip="Caso o pedido tenha contrato dele derivado, deve ser inserido o número do contrato"
						></label-personalizado>
						<v-text-field
							:key="'contratosVinculados'"
							v-model="contratosVinculados"
							:disabled="(!isPedidoRascunho && !hasAuthority) || isAtaCancelada"
							class="v-text-field__arp-margin"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="3" v-if="usaNumeroEmpenho">
						<label-personalizado
							nome-campo="N° Empenho"
							:obrigatorioPorPadrao="numeroEmpenhoObrigatorio"
							:mensagemPadraoTooltip="tooltipMascaraNumeroEmpenho"
							:apresentaTooltip="numeroEmpenhoMascaraObrigatoria"
						></label-personalizado>
						<campo-mascara-regex
							id="numeroEmpenho"
							v-model="numeroEmpenho"
							name="N° Empenho"
							clearable
							:rules="regrasNumeroEmpenho"
							:validate="{
								required: numeroEmpenhoObrigatorio,
								regex: validacaoMascaraNumeroEmpenho,
							}"
							maxlength="50"
							placeholder="Informe o número do empenho"
							:regex="mascaraNumeroEmpenho"
							:disabled="
								(!isPedidoRascunho && !hasAuthority) ||
								!verificarPermissao(permissoes.pedidoUtilizacaoNumeroEmpenhoEditar) ||
								!isPermissaoAutorizada(permissoes.pedidoUtilizacaoNumeroEmpenhoEditar) ||
								isAtaCancelada
							"
						></campo-mascara-regex>
					</v-col>
					<v-col cols="12" :sm="usaNumeroEmpenho ? 3 : 4" class="d-flex justify-end">
						<span class="valorTotal">
							<label-personalizado
								nome-campo="Total Geral"
								:obrigatorioPorPadrao="false"
							></label-personalizado>
							<span class="valor">{{ totalPedido | azCurrency(numeroCasasDecimaisValores) }}</span>
						</span>
					</v-col>
				</v-row>
				<v-divider></v-divider>
				<div v-if="podeExibirSecaoProtocolo" class="my-8">
					<span class="font-weight-bold primary--text">Protocolo</span>
					<v-row class="my-3">
						<v-col cols="12" sm="3">
							<label-personalizado
								nome-campo="Espécie Documental"
								:obrigatorioPorPadrao="true"
							></label-personalizado>
							<v-tooltip top color="black" :disabled="!especieDocumentalSelecionada">
								<template #activator="{ on }">
									<v-autocomplete
										v-on="on"
										id="pedido-protocolo-especie-documental"
										v-model="especieDocumentalSelecionada"
										:items="especiesDocumentais"
										:rules="regrasEspecieDocumental"
										item-value="id"
										item-text="descricaoFormatada"
										placeholder="Selecione"
										dense
										clearable
										:disabled="!podeEditarProtocolo"
										class="v-autocomplete-almox-margin"
									>
									</v-autocomplete>
								</template>
								<span>{{
									(especiesDocumentais.find((e) => e.id === especieDocumentalSelecionada) || {}).descricaoFormatada
								}}</span>
							</v-tooltip>
						</v-col>
						<v-col cols="12" sm="6">
							<label-personalizado
								nome-campo="Observações"
								:obrigatorioPorPadrao="true"
							></label-personalizado>
							<v-textarea
								id="pedido-protocolo-observacoes"
								v-model="observacoesProtocolo"
								:rules="regrasObservacoesProtocolo"
								:disabled="!podeEditarProtocolo"
								maxlength="4000"
								counter="4000"
								rows="1"
								auto-grow
								class="v-text-field__arp-margin"
							></v-textarea>
						</v-col>
						<v-col v-if="podeEditarProtocolo" cols="12" sm="2" class="mt-4">
							<botao-primario
								id="pedido-protocolo-protocolar"
								outlined
								nome-botao="PROTOCOLAR"
								:disabled="!podeEditarProtocolo || protocolando"
								@click="protocolarPedido"
							></botao-primario>
						</v-col>
					</v-row>
				</div>
				<v-divider v-if="podeExibirSecaoProtocolo"></v-divider>
				<div class="my-8">
					<span class="font-weight-bold primary--text">Entrega do Pedido</span>
					<v-row class="my-3">
						<v-col cols="12" sm="3">
							<label-personalizado nome-campo="Local de Entrega"></label-personalizado>
							<v-autocomplete
								id="pedido-almoxarifado"
								v-model="almoxarifadoSelecionado"
								:items="almoxarifados"
								placeholder="Selecione"
								item-value="id"
								item-text="sigla"
								dense
								clearable
								:disabled="(!isPedidoRascunho && !hasAuthority) || isAtaCancelada"
								@change="alterarEnderecoEntrega"
								class="v-autocomplete-almox-margin"
							>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" :sm="usaNumeroEmpenho ? 6 : 5">
							<label-personalizado nome-campo="Endereço"></label-personalizado>
							<v-text-field
								:key="'enderecoEntrega'"
								v-model="enderecoEntrega"
								:disabled="(!isPedidoRascunho && !hasAuthority) || isAtaCancelada"
								class="v-text-field__arp-margin"
							></v-text-field>
						</v-col>
					</v-row>
				</div>
			</div>
		</v-form>
		<v-divider></v-divider>
		<listagem-collapses-dotacao-orcamentaria
			:items="listagemDotacoes.datasource"
			:paginacao="listagemDotacoes.paginacao"
			:total-itens="listagemDotacoes.totalItens"
			:total-paginas="listagemDotacoes.totalPaginas"
			:valorTotalEstimado="listagemDotacoes.valorTotalEstimado"
			:info-pedido="informacoesPedido"
			@botao-evento="exibirModalIncluir = true"
			@paginar="setPaginacaoListagem"
			@recarregar-dotacoes="carregarDotacaoes"
		></listagem-collapses-dotacao-orcamentaria>
		<div class="mt-4">
			<botao-cancelar-confirmar
				:acao-confirmar="salvar"
				:acao-cancelar="cancelar"
				:nome-botao-confirmar="'SALVAR'"
				:is-confirmar-visivel="(isPedidoRascunho || hasAuthority) && !isAtaCancelada"
			></botao-cancelar-confirmar>
		</div>

		<modal-confirmacao
			id="excluirItemPedido"
			:exibir="exibirModalExclusaoItem"
			:mensagem="mensagemExclusaoItem"
			@fechar-modal="abrirModalConfirmacaoExclusao"
			@confirmar="excluirItem"
			:subtituloModal="subtituloModalExclusao"
			:tituloModal="tituloModalexclusao"
		></modal-confirmacao>
		<modal-estorno-item-pedido
			:itens="itensSelecionados"
			:exibir="exibirModalEstornoItem"
			@carregar-listagem="buscarItensPedido"
			@fechar-modal="fecharModalEstornoItemPedido"
			:is-estornar="isExibirModalComAcaoEstornarItem"
		></modal-estorno-item-pedido>
	</div>
</template>
<script>
import { actionTypes, getterTypes, mutationTypes, routesNames, situacoes, tipoAcesso } from '@/core/constants'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import AcessarPedidoItensListagem from '@/views/pages/pedido/acessar/itens/listagem/AcessarPedidoItensListagem.vue'
import DeletarItemPedidoInput from '@/core/apiclient/item-pedido/models/DeletarItemPedidoInput'
import { mapGetters, mapState } from 'vuex'
import SalvarPedidoInput from '@/core/apiclient/pedido/models/SalvarPedidoInput'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import cabecalhoPedido from '@/views/mixins/cabecalhoPedido'
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'
import ListagemCollapsesDotacaoOrcamentaria from '@/views/pages/pedido/acessar/itens/listagem-dotacao-orcamentaria/ListagemCollapsesDotacaoOrcamentaria.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import ModalIncluirDotacaoOrcamentaria from './modal/incluir-dotacao-orcamentaria/ModalIncluirDotacaoOrcamentaria.vue'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import BotaoCancelarConfirmar from '@/views/components/BotaoCancelarConfirmar.vue'
import ModalEstornoItemPedido from '@/views/pages/pedido/acessar/itens/estorno/ModalEstornoItemPedido.vue'
import AcessarPedidoItensBtnMaisAcoes from '@/views/pages/pedido/acessar/itens/botoes/AcessarPedidoItensBtnMaisAcoes.vue'
import fluxoPedido from '@/views/mixins/bpm/fluxoPedido'
import CampoMascaraRegex from '@/views/components/CampoMascaraRegex.vue'

export default {
	name: 'acessar-pedido-itens-view',
	components: {
		BotaoPrimario,
		LabelPersonalizado,
		CampoMascaraRegex,
		BotaoCancelarConfirmar,
		ModalConfirmacao,
		AcessarPedidoItensBtnMaisAcoes,
		ModalEstornoItemPedido,
		AcessarPedidoItensListagem,
		ListagemCollapsesDotacaoOrcamentaria,
		ModalIncluirDotacaoOrcamentaria,
	},
	mixins: [validacaoFormulario, validacaoPedido, cabecalhoPedido, arpBpmMixin, fluxoPedido],
	inject: ['numeroDoPedidoIsManual', 'idPedido', 'isEditar', '$validator'],
	data() {
		return {
			listagemDotacoes: {
				datasource: [],
				totalPaginas: 0,
				totalItens: 0,
				valorTotalEstimado: 0,
				paginacao: PaginacaoListagem(['exercicio'], 999),
			},
			listagem: {
				totalItens: 0,
				totalPaginas: 0,
				paginacao: PaginacaoListagem(['seq']),
				datasource: [],
			},
			listagemDotacaoOrcamentariaSetup: {
				totalItens: 0,
				totalPaginas: 1,
				paginacao: PaginacaoListagem(['seq'], 10),
				datasource: [],
			},
			formRodapeIsValid: false,
			exibirModalExclusaoItem: false,
			exibirModalIncluir: false,
			exibirModalEstornoItem: false,
			isExibirModalComAcaoEstornarItem: false,
			mensagemExclusaoItem: 'O item excluído não poderá ser recuperado!',
			subtituloModalExclusao: 'Deseja realmente excluir?',
			tituloModalexclusao: 'Excluir',
			tituloModalIncluirDotacao: 'Seleção de Dotação Orçamentária',
			regrasNumeroProcesso: [
				(value) => {
					if (!this.numeroProcessoObrigatorio) {
						return true
					}

					return this.regraObrigatoriedade(value, 'O campo é obrigatório.')
				},
			],
			regrasNumeroEmpenho: [
				(value) => {
					if (this.numeroEmpenhoObrigatorio) {
						return this.regraObrigatoriedade(value, 'O campo é obrigatório.')
					}

					return true
				},
			],
			regrasEspecieDocumental: [(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.')],
			regrasObservacoesProtocolo: [
				(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.'),
				(value) => !value || value.length <= 4000 || 'O campo deve possuir no máximo 4000 caracteres.',
			],
			numeroProcesso: null,
			contratosVinculados: null,
			numeroEmpenho: null,
			enderecoEntrega: null,
			especieDocumentalSelecionada: null,
			observacoesProtocolo: null,
			especiesDocumentais: [],
			protocolando: false,
			itensSelecionados: [],
			permissoesBotoesAcoesEmMassa: this.getTodasPermissoesAcoesEmMassa(),
			totalPedido: 0.0,
			podeAlterarNumeroProcesso: false,
			almoxarifadoSelecionado: null,
			almoxarifados: [],
		}
	},
	computed: {
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.pedido.numeroCasasDecimaisValores
			},
		},
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.pedido.numeroCasasDecimaisQtde
			},
		},
		...mapGetters({
			isPedidoRascunho: getterTypes.PEDIDO.IS_PEDIDO_RASCUNHO,
		}),
		...mapState({
			filtro: (state) => state.itemPedido.filtro,
			itensSelecionadosListagem: (state) => state.itemPedido.itensSelecionados,
			parametrosSistema: (state) => state.parametrosSistema,
			infoPedido: (state) => state.pedido.informacoesPedido,
		}),
		botaoAcoesEmMassaPodeAparecer() {
			return this.validarPermissoesBotoesAcoesEmMassa()
		},
		ehMascaraNumeroProcessoAtivo() {
			return !this.podeExibirSecaoProtocolo && this.parametrosSistema.regexMascaraNumeroProcessoAtivo
		},
		mascaraNumeroProcesso() {
			return this.ehMascaraNumeroProcessoAtivo ? this.parametrosSistema.regexMascaraNumeroProcesso : null
		},
		tooltipMascaraNumeroProcesso() {
			return this.parametrosSistema.regexMascaraNumeroProcessoTooltip
		},
		validacaoMascaraNumeroProcesso() {
			return this.ehMascaraNumeroProcessoAtivo ? this.mascaraNumeroProcesso : ''
		},
		usaNumeroEmpenho() {
			return this.parametrosSistema.numeroEmpenhoAtivo
		},
		numeroEmpenhoObrigatorio() {
			return this.parametrosSistema.numeroEmpenhoObrigatorio
		},
		numeroEmpenhoMascaraObrigatoria() {
			return this.parametrosSistema.numeroEmpenhoMascaraObrigatoria
		},
		mascaraNumeroEmpenho() {
			return this.numeroEmpenhoMascaraObrigatoria ? this.parametrosSistema.numeroEmpenhoRegex : null
		},
		tooltipMascaraNumeroEmpenho() {
			return this.parametrosSistema.numeroEmpenhoTooltip
		},
		validacaoMascaraNumeroEmpenho() {
			return this.numeroEmpenhoMascaraObrigatoria ? this.mascaraNumeroEmpenho : ''
		},
		isAtaCancelada() {
			return this.infoPedido.ataRegistroPreco?.situacao === situacoes.ATA.CANCELADO.value
		},
		podeExibirSecaoProtocolo() {
			return this.pedidoProtocolado || (this.parametrosSistema.isIntegracaoSpiAtivo && this.isPedidoRascunho)
		},
		numeroProcessoObrigatorio() {
			return !this.podeExibirSecaoProtocolo
		},
		pedidoProtocolado() {
			return Boolean(
				this.informacoesPedido.protocolo?.protocolado ||
					this.informacoesPedido.protocolado ||
					this.informacoesPedido.numeroProtocolo ||
					this.informacoesPedido.idProtocolo,
			)
		},
		podeEditarProtocolo() {
			return (
				this.podeExibirSecaoProtocolo &&
				!this.pedidoProtocolado &&
				!this.isAtaCancelada &&
				(this.hasAuthority || this.isPedidoRascunho)
			)
		},
		dadosProtocolo() {
			return {
				idEspecie: this.especieDocumentalSelecionada,
				textoComplementar: this.observacoesProtocolo,
			}
		},
	},
	beforeDestroy() {
		this.resetarPaginaListagem()
		this.$store.commit(mutationTypes.ITEM_PEDIDO.RESET_FILTRO_LISTAGEM)
	},
	async created() {
		try {
			this.ativarCarregamentoManual()

			await this.inicializarComponente()
		} finally {
			this.desativarCarregamentoManual()
		}
	},
	methods: {
		async carregarTotal() {
			const { valorTotal } = await this.$store.dispatch(actionTypes.PEDIDO.CALCULAR_TOTAL, this.idPedido)
			this.totalPedido = valorTotal
		},
		async inicializarComponente() {
			await Promise.all([
				this.carregarInstancia(`${this.idPedido}`),
				this.buscarItensPedido(),
				this.carregarTotal(),
				this.buscarInformacoesDoPedido(),
				this.carregarEspeciesDocumentaisProtocolo(),
				this.carregarDotacaoes(),
				this.buscarAlmoxarifados(),
			])
			this.inicializarFormularioRodape()
			this.verificarPodeAlterarNumeroProcesso()
		},
		async buscarItensPedido() {
			let { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_PEDIDO.BUSCAR_ITENS,
				{ filtro: this.filtro, paginacao: this.listagem.paginacao, idPedido: this.idPedido },
			)

			this.listagem.datasource = this.getItensListagem(itens)
			this.listagem.totalItens = totalElements
			this.listagem.totalPaginas = totalPages
		},
		async buscarFiltro(searchText) {
			if (searchText) this.filtro.tipoOuDescricao.value = searchText
			this.resetarPaginaListagem()
			await this.buscarItensPedido()
		},
		async removerFiltros() {
			if (this.filtro.tipoOuDescricao.value) {
				this.filtro.tipoOuDescricao.value = this.filtro.tipoOuDescricao.default
			}
			await this.buscarItensPedido()
		},
		async salvar() {
			if (this.podeEditarProtocolo) {
				this.mostrarNotificacaoErro('É necessário protocolar o pedido para prosseguir.')
				return
			}

			if (this.$refs.form.validate() && this.validarNumeroPedido()) {
				await this.$store.dispatch(
					actionTypes.PEDIDO.SALVAR_PEDIDO,
					new SalvarPedidoInput(
						this.idPedido,
						this.numeroProcesso,
						this.contratosVinculados,
						this.getSituacaoSalvar(),
						this.enderecoEntrega,
						this.almoxarifadoSelecionado,
						this.numeroEmpenho,
					),
				)

				if (this.numeroIsAutomatico) {
					await this.carregarCabecalho()
				}

				await this.buscarAlmoxarifados()

				this.mostrarNotificacaoSucesso('O pedido foi salvo com sucesso!')
			}
		},
		cancelar() {
			this.limparFormularioRodape()
		},
		async excluirItem() {
			await this.$store.dispatch(
				actionTypes.ITEM_PEDIDO.EXCLUIR_ITEM,
				new DeletarItemPedidoInput(this.itemParaExcluir.idItemPedido),
			)
			await this.buscarItensPedido()
			this.abrirOuFecharModalExclusao()
			this.mostrarNotificacaoSucesso('Item do pedido foi excluído com sucesso!')
			if (this.listagem.datasource.length === 0) this.resetarPaginaListagem()
			await this.carregarTotal()
		},
		async irParaSelecaoItens() {
			await this.$router.push({
				name: routesNames.PEDIDO.NOVO_VIEW,
				params: { id: this.idPedido, tipoAcesso: tipoAcesso.SELECAO_ITEM_PEDIDO.EDITAR },
			})
		},
		async paginarListagem(paginacao) {
			this.setPaginacaoItensPedidoListagem(paginacao)
			await this.buscarItensPedido()
		},
		inicializarFormularioRodape() {
			this.numeroProcesso = this.informacoesPedido.numeroProcesso
			this.contratosVinculados = this.informacoesPedido.contratosVinculados
			this.numeroEmpenho = this.informacoesPedido.numeroEmpenho
			this.enderecoEntrega = this.informacoesPedido.enderecoEntrega
			this.inicializarFormularioProtocolo()
			this.almoxarifadoSelecionado = this.informacoesPedido.uoAlmoxarifado
				? this.informacoesPedido.uoAlmoxarifado.id
				: null
		},
		inicializarFormularioProtocolo() {
			const protocolo = this.informacoesPedido.protocolo || {}
			const especieDocumental = protocolo.especieDocumental || this.informacoesPedido.especieDocumental || {}

			this.especieDocumentalSelecionada =
				protocolo.idEspecie ||
				protocolo.idEspecieDocumental ||
				especieDocumental.id ||
				especieDocumental.codigo ||
				null
			this.observacoesProtocolo =
				protocolo.textoComplementar ||
				protocolo.observacao ||
				protocolo.observacoes ||
				this.informacoesPedido.observacao ||
				null

			this.adicionarEspecieDocumentalSelecionadaSeNecessario(especieDocumental)
		},
		adicionarEspecieDocumentalSelecionadaSeNecessario(especieDocumental) {
			const descricao = especieDocumental?.descricao || especieDocumental?.nome
			if (!this.especieDocumentalSelecionada || !descricao) return

			const idSelecionado = String(this.especieDocumentalSelecionada)
			const especieJaCarregada = this.especiesDocumentais.some((especie) => String(especie.id) === idSelecionado)

			if (especieJaCarregada) return

			const [especieFormatada] = this.formatarEspeciesDocumentais([especieDocumental])
			this.especiesDocumentais = [...this.especiesDocumentais, especieFormatada]
		},
		verificarPodeAlterarNumeroProcesso() {
			this.podeAlterarNumeroProcesso = this.informacoesPedido.podeAlterarNumeroProcesso
		},
		abrirModalEstornoItemPedido(itens, isEstorno) {
			this.itensSelecionados = itens
			this.isExibirModalComAcaoEstornarItem = isEstorno
			this.exibirModalEstornoItem = !this.exibirModalEstornoItem
		},
		fecharModalEstornoItemPedido() {
			this.itensSelecionados = []
			this.exibirModalEstornoItem = false
		},
		abrirModalConfirmacaoExclusao(item) {
			this.itemParaExcluir = item
			this.abrirOuFecharModalExclusao()
		},
		abrirOuFecharModalExclusao() {
			this.exibirModalExclusaoItem = !this.exibirModalExclusaoItem
		},
		setPaginacaoItensPedidoListagem(paginacao) {
			this.$store.commit(mutationTypes.ITEM_PEDIDO.SET_PAGINACAO_LISTAGEM, paginacao)
		},
		resetarPaginaListagem() {
			this.$store.commit(mutationTypes.ITEM_PEDIDO.RESETAR_PAGINA_LISTAGEM)
		},
		getItensListagem(itens) {
			return itens.map((item) => {
				item._quantidadeSolicitada = item.quantidadeSolicitada
				item._unidadeDespesa = null
				item.isEditarQuantidadeSolicitada = false
				item.isEditarUnidadeDespesa = false
				return item
			})
		},
		getItensListagemDotacao(itens) {
			return itens.map((item) => {
				item._valor = item.valor
				item.isEditarValor = false
				return item
			})
		},
		validarNumeroPedido() {
			if (this.informacoesPedido.numeroPedido || this.numeroIsAutomatico()) {
				return true
			} else {
				this.mostrarNotificacaoErro('Número do pedido não informado.')
				return false
			}
		},
		getSituacaoSalvar() {
			return this.estaEmRascunho(this.informacoesPedido) ? situacoes.PEDIDO.EM_ELABORACAO.value : null
		},
		numeroIsAutomatico() {
			return !this.numeroDoPedidoIsManual
		},
		limparFormularioRodape() {
			this.limparCampoNumeroProcesso()
			this.limparCampoContratosVinculados()
			this.limparEnderecoEntrega()
			this.limparFormularioProtocolo()
		},
		limparCampoNumeroProcesso() {
			if (this.informacoesPedido.numeroProcesso !== this.numeroProcesso) {
				this.limparCampoFormulario('numeroProcesso')
			}
		},
		limparCampoContratosVinculados() {
			if (this.informacoesPedido.contratosVinculados !== this.contratosVinculados) {
				this.limparCampoFormulario('contratosVinculados')
			}
		},
		limparEnderecoEntrega() {
			if (this.informacoesPedido.enderecoEntrega !== this.enderecoEntrega) {
				this.limparCampoFormulario('enderecoEntrega')
			}
		},
		limparFormularioProtocolo() {
			this.inicializarFormularioProtocolo()
		},
		limparCampoFormulario(nome) {
			this[nome] = this.informacoesPedido[nome]
			this.$refs.form.resetValidation(nome)
		},
		getFiltroBusca(idOrgao, situacoes) {
			return {
				filtro: {
					paginacao: paginacaoListagem(['id']),
					idAta: this.$route.params.id,
					idOrgao: idOrgao,
					situacoes: situacoes,
				},
				paginacao: paginacaoListagem(['id']),
			}
		},
		setPaginacaoListagem(paginacao) {
			this.listagemDotacoes.paginacao = paginacao
			this.carregarDotacaoes()
		},
		async carregarDotacaoes() {
			let { itens, totalElements, totalPages, valorTotalEstimado } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.BUSCAR_LISTAGEM_PAGINADA,
				this.idPedido,
			)

			this.listagemDotacoes.datasource = this.getItensListagemDotacao(itens)
			this.listagemDotacoes.totalItens = totalElements
			this.listagemDotacoes.totalPaginas = totalPages
			this.listagemDotacoes.valorTotalEstimado = valorTotalEstimado
		},
		validarPermissoesBotoesAcoesEmMassa() {
			const permissoes = this.permissoesBotoesAcoesEmMassa
			return permissoes.estornar()
		},
		getTodasPermissoesAcoesEmMassa() {
			return {
				estornar: () => this.podeEstornar(),
			}
		},
		podeEstornar() {
			return (
				this.isEditar &&
				this.itemEstaEfetivado(this.informacoesPedido) &&
				this.hasAuthority &&
				this.isPermissaoAutorizada(this.permissoes.pedidoUtilizacaoItemEstornar)
			)
		},
		isPedidoEfetivado() {
			return this.itemEstaEfetivado(this.informacoesPedido)
		},
		async baixarRelatorioPrevio() {
			await this.$store.dispatch(actionTypes.PEDIDO.BAIXAR_RELATORIO_PREVIO, this.idPedido)
		},
		async buscarAlmoxarifados() {
			const { itens } = await this.$store.dispatch(actionTypes.PEDIDO.BUSCAR_ALMOXARIFADOS, this.idPedido)
			this.almoxarifados = itens
		},
		async carregarEspeciesDocumentaisProtocolo() {
			if (!this.parametrosSistema.isIntegracaoSpiAtivo) return

			const especiesDocumentais = await this.$store.dispatch(
				actionTypes.PEDIDO.PROTOCOLO.BUSCAR_ESPECIES_DOCUMENTAIS,
			)

			this.especiesDocumentais = this.formatarEspeciesDocumentais(especiesDocumentais)
		},
		formatarEspeciesDocumentais(especiesDocumentais) {
			const itens = especiesDocumentais?.itens || especiesDocumentais || []

			return itens.map((especie) => {
				const codigo = especie.codigo || especie.id
				const descricao = especie.descricao || especie.nome

				return {
					...especie,
					id: especie.id || especie.codigo,
					descricaoFormatada: codigo ? `${codigo} - ${descricao}` : descricao,
				}
			})
		},
		validarFormularioProtocolo() {
			if (!this.especieDocumentalSelecionada || !this.observacoesProtocolo) {
				this.mostrarNotificacaoErro('Preencha os dados de protocolo para prosseguir.')
				return false
			}

			if (this.observacoesProtocolo.length > 4000) {
				this.mostrarNotificacaoErro('O campo Observações deve possuir no máximo 4000 caracteres.')
				return false
			}

			return true
		},
		async protocolarPedido() {
			if (!this.validarFormularioProtocolo()) return

			try {
				this.protocolando = true

				await this.$store.dispatch(actionTypes.PEDIDO.PROTOCOLO.PROTOCOLAR, {
					idPedido: this.idPedido,
					dadosProtocolo: this.dadosProtocolo,
				})

				await this.buscarInformacoesDoPedido()
				this.inicializarFormularioRodape()
				this.verificarPodeAlterarNumeroProcesso()
				await this.carregarCabecalho()

				this.mostrarNotificacaoSucesso('Pedido protocolado com sucesso!')
			} finally {
				this.protocolando = false
			}
		},
		alterarEnderecoEntrega() {
			if (this.almoxarifadoSelecionado !== null) {
				const { enderecoFormatado } = this.almoxarifados.find(
					(almox) => almox.id === this.almoxarifadoSelecionado,
				)
				this.enderecoEntrega = enderecoFormatado
			}
		},
	},
}
</script>
<style lang="stylus">
.v-text-field__arp-margin
	margin-top -0.55rem !important

.v-autocomplete-almox-margin
	padding-top 0.3rem !important

.valorTotal
	display flex
	flex-direction column
	align-items end

	.titulo
		font-size 12px
</style>
